import { AnimatePresence, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { DateInfo } from "@/core/constants/dateInfo";
import { imgTabletBackgroundLock } from "@/shared/assets/img";
import { Icon } from "@/shared/ui";

type Props = {
  isLock: boolean;
  currentTime: DateInfo;
  onClick: () => void;
};

export default function TabletLockScreen({ isLock, currentTime, onClick }: Props) {
  const { month, day, hours, minutes, weekday } = currentTime;
  const { t } = useTranslation("tablet");

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <AnimatePresence>
      {isLock && (
        <motion.div
          className="absolute z-10 top-0 left-0 flex flex-wrap size-full bg-no-repeat bg-cover"
          style={{
            backgroundImage: `url(${imgTabletBackgroundLock})`,
          }}
          onClick={onClick}
          initial={{ y: 0 }}
          animate={{ y: 0 }}
          exit={{ y: "-100%" }}
          transition={{ duration: 0.35, ease: "easeInOut" }}
        >
          <div className="w-full">
            <div className="flex w-full justify-between items-center mb-7.5 pt-4 px-3.5">
              <p className="text-13 font-medium">
                {hours}:{minutes}, {t(`days.${weekday}`)}, {day} {t(`months.${month}`)}
              </p>
              <div className="flex items-center gap-1.5">
                <Icon name="signal" category="tablet" className="w-4.5" />
                <Icon name="wifi" category="tablet" className="w-4" />
                <Icon name="battery" category="tablet" className="w-6" />
              </div>
            </div>
            <div className="flex flex-col items-center w-full">
              <Icon name="locked" category="tablet" className="w-5 h-6" />
              <p className="text-[5rem]">
                {hours}:{minutes}
              </p>
              <p className="text-20">
                {t(`days.${weekday}`)}, {day} {t(`months.${month}`)}
              </p>
            </div>
          </div>
          <div className="flex flex-col items-center gap-7.5 mt-auto mb-2.5 mx-auto">
            <p>{t("touchToLockScreen")}</p>
            <div className="w-25 h-1 bg-white rounded-[0.25rem]" />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
